
































import Vue from "vue";

export default Vue.extend({
  name: "TableSearch",
  data: function () {
    return {
      input: "",
    };
  },
  methods: {
    emitChange(text: string) {
      this.input = text;
      this.$emit("change", this.input);
    },
    emitClick() {
      this.$emit("search", this.input);
    },
    timeClick() {
      this.input = "";
      this.emitClick();
    },
  },
});
